// extracted by mini-css-extract-plugin
module.exports = {"Intro":"EnterName_Intro__1AFxE","NameInput":"EnterName_NameInput__35Yzq","Buttons":"EnterName_Buttons__H4GzP"};